import Information from './Information'
import Setting from './Setting'

const Hosting = {
    Information,
    Setting,
}

export default Hosting
